<template>
    <div class="ls-dismissible-notice">
        <div>
            <img v-if="leftImage === 'success'" :src="require('./assets/success.svg')" />
            <img v-if="leftImage === 'failure'" :src="require('./assets/failure.svg')" />
            <span>{{ label }}</span>
        </div>
        <img
            class="ls-dismissible-notice--cancel"
            :src="require('./assets/cancel.svg')"
            test-id="dismiss"
            @click="$emit('click')"
        />
    </div>
</template>

<script>
import VueTypes from 'vue-types';

export default {
    name: 'LsDismissibleNotice',
    props: {
        leftImage: VueTypes.oneOf(['success', 'failure']).isRequired,
        label: VueTypes.string.isRequired,
    },
};
</script>

<style lang="scss" scoped>
.ls-dismissible-notice {
    background-color: $secondary-lighter;
    line-height: 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 7px 10px;

    div {
        display: flex;
        align-items: center;
    }

    span {
        color: $secondary;
        margin-left: 6px;
    }
}

.ls-dismissible-notice--cancel {
    transform: rotate(45deg);
    cursor: pointer;
}
</style>
